import React, { useState, useCallback, useContext, useRef, useEffect } from "react";
import styles from "./index.module.less";
import ThirdAppHeader from "../ThirdAppHeader";
import ModalAppTool from "@/components/ThirdApp/components/ModalAppTool";
import ModalCardTool from "@/components/ThirdApp/components/ModalCardTool";
import {
  TodoCard,
  NewsBannerCard,
  AddCard,
  OfflineCard,
  NewAddedThirdapp,
  NotFoundCard
} from "../ThirdAppCardGroup";
import Bus from "@/utils/bus";
import { ThirdAppContext } from "@/components/ThirdApp/utils";
import { ICardRes, ICard } from "../../interface";
import ThirdApplications from "../ThirdApplications";
import CustomWorkbench from "../CustomWorkbench";
import { connect } from "dvajs";
import ScrollView from "@/baseComponents/ScrollView";

const obj: { [key: string]: any } = {
  TodoCard,
  NewsBannerCard,
  NewAddedThirdapp,
  NotFoundCard
};

interface IProps {
  groups?: any;
  cards: ICardRes;
  isPrivateNet?: boolean;
  openAppStore?: () => void;
  onCardsOrderChange?: (newCards: any) => void;
  onAddCard?: (card: ICard) => void;
  onDeleteCard?: (card: ICard) => void;
  hasNewStoreApp?: boolean;
  currentSelectedWorkbench?: any;
  getAppListAll: Function;
  isApplications?: boolean;
  localstorageKey: string;
}

function ThirdAppContainer({
  groups,
  cards,
  openAppStore,
  onCardsOrderChange,
  isPrivateNet,
  onAddCard,
  onDeleteCard,
  hasNewStoreApp,
  currentSelectedWorkbench,
  getAppListAll,
  isApplications,
  localstorageKey
}: IProps) {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isCardVisible, setIsCardVisible] = useState<boolean>(false);
  const { isOnline, isActive } = useContext(ThirdAppContext);
  const [modalFromLayoutId, setModalFromLayoutId] = useState("");
  const scrollRef = useRef(null);
  // const [theCards, setTheCards] = useState(cards);

  const openNewPage: (data: { item: ICard; url: string }) => void = useCallback((data) => {
    console.log("this is new page", data);
    Bus.emit("openThirdAppByWorkPlateCard", data);
  }, []);

  const onCancelModalAppTool = () => {
    setIsModalVisible(false);
    if (modalFromLayoutId) {
      // Bus.emit(`card:refresh:${modalFromLayoutId}`);
      setModalFromLayoutId("");
    }
  };
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log("xtlisonline~~~:", isOnline);
  }, [isOnline]);

  const onCancelModalCardTool = () => {
    setIsCardVisible(false);
  };

  const onManageFavoriteApp = useCallback(
    (cardLayoutId?: any) => {
      console.log("wtfisonlineis?", isOnline);
      if (!isOnline) {
        return false;
      }
      cardLayoutId && setModalFromLayoutId(cardLayoutId);
      setIsModalVisible(true);
    },
    [isOnline]
  );

  const onManageCard = () => {
    if (!isOnline) {
      return false;
    }
    setIsCardVisible(true);
  };

  const cardChildren = cards?.addedCards?.map((item: ICard) => {
    const Cmp = obj[item.contentDeeplink];
    if (!item) {
      return "";
    }
    if (!Cmp) {
      return <NotFoundCard key={item?.cardId} cardInfo={item} />;
    }
    const child = isOnline ? (
      <Cmp
        key={item.cardId}
        cardInfo={item}
        openNewPage={openNewPage}
        isPrivateNet={isPrivateNet}
      />
    ) : (
      <OfflineCard />
    );
    // item.openNewPage = openNewPage;
    return child;
  });
  cardChildren?.push(<AddCard onManageCard={onManageCard} />);

  return (
    <>
      {!isApplications && (
        <ThirdAppHeader
          openAppStore={openAppStore}
          onManageFavoriteApp={onManageFavoriteApp}
          onManageCard={onManageCard}
          hasNewStoreApp={hasNewStoreApp}
          getAppListAll={getAppListAll}
          localstorageKey={localstorageKey}
        />
      )}

      {!isApplications && currentSelectedWorkbench.workBenchType === 1 ? (
        <CustomWorkbench onManageFavoriteApp={onManageFavoriteApp} />
      ) : (
        <div
          className={`${styles["container"]} ${
            isApplications ? styles["container_only_thirdapps"] : ""
          }`}
        >
          <div className={styles["tools"]}>
            <ThirdApplications
              isApplications={isApplications}
              groups={groups}
              onManageFavoriteApp={onManageFavoriteApp}
            />
          </div>
          {!isApplications && (
            <div className={styles["cards"]}>
              <ScrollView ref={scrollRef} autoHide>
                {isActive ? cardChildren : ""}
              </ScrollView>
            </div>
          )}
        </div>
      )}
      <ModalAppTool
        isModalVisible={isModalVisible}
        groups={groups}
        onCancel={onCancelModalAppTool}
        cardLayoutId={modalFromLayoutId}
      />
      {!isApplications && (
        <ModalCardTool
          isModalVisible={isCardVisible}
          cards={cards}
          onCancel={onCancelModalCardTool}
          onCardsOrderChange={onCardsOrderChange}
          onAddCard={onAddCard}
          onDeleteCard={onDeleteCard}
        />
      )}
    </>
  );
}
function mapStateToProps({ workbench }: { workbench: any }) {
  const { currentSelectedWorkbench } = workbench;
  return {
    currentSelectedWorkbench
  };
}

function mapDispatchToProps() {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(ThirdAppContainer);
